export const languageCode = 'it';
export const languageLabel = 'Italian';

export const translations = {
  AUDIO_DESCRIPTION_OFF: 'Spento',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: 'Nascondere menu sottotitoli',
  CAPTIONS_OFF: 'Spento',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: 'Cerca Video',
  CAPTIONS_SHOW_MENU: 'Mostrare menu sottotitoli',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: 'Chiudere capitoli',
  CHAPTERS_OPEN_CHAPTERS: 'Aprire capitoli',

  CLICK_FOR_SOUND_DESKTOP_TEXT: 'Cliccare per il suono',
  CLICK_FOR_SOUND_MOBILE_TEXT: 'Schiacciare per il suono',

  CONTEXT_MENU_ABOUT_WISTIA: 'A proposito di Wistia',
  CONTEXT_MENU_COPIED: 'Copiato!',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: "Copiare il link e l'anteprima",
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: 'Connesso a Wistia',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: 'Apri video in Wistia',
  CONTEXT_MENU_REPORT_A_PROBLEM: 'Segnala un problema',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: 'Visualizza le statistiche in Wistia',

  CUSTOMER_LOGO_LOGO: 'Logo',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: 'Disattivare lo schermo intero',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: 'Attivare lo schermo intero',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: 'Video',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: 'Riprodurre',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: 'Pausa',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: 'Si prega di aggiungere dettagli',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: 'Sceglierne uno',
  REPORT_A_PROBLEM_DESCRIPTION:
    'Grazie per aver segnalato un problema. Allegheremo i dati tecnici su questa sessione per aiutarci a capire il problema. Quale di questi casi descrive meglio il problema?',
  REPORT_A_PROBLEM_DISMISS: 'Ignorare',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: 'Il video non funziona',
  REPORT_A_PROBLEM_OTHER: 'Altro',
  REPORT_A_PROBLEM_OTHER_CONTEXT: 'Qualche altro dettaglio o contesto?',
  REPORT_A_PROBLEM_POOR_QUALITY: 'Il video ha una scarsa qualità',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: 'Categoria problema',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: 'Descrizione del problema',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: 'Si prega di selezionare una categoria',
  REPORT_A_PROBLEM_SEND: 'Inviare',
  REPORT_A_PROBLEM_SENDING: 'Invio ...',
  REPORT_A_PROBLEM_STUTTER: 'Il video viene riprodotto, ma spesso balbetta',

  REWATCH: 'Rivedi',

  SETTINGS_PLAYBACK_RATE_TITLE: 'Velocità',
  SETTINGS_QUALITY_AUTO: 'Auto',
  SETTINGS_QUALITY_TITLE: 'Qualità',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: 'Chiudere il menu di condivisione',
  SHARE_CONTROL_OPEN: 'Aprire il menu di condivisione',
  SHARE_COPIED: 'Copiato!',
  SHARE_DOWNLOAD: 'Scaricare',
  SHARE_EMAIL: 'E-mail',
  SHARE_EMBED: 'Incorporare',
  SHARE_FACEBOOK: 'Facebook',
  SHARE_LINKED_IN: 'LinkedIn',
  SHARE_TWITTER: 'Twitter',

  SKIP: 'Salta',

  STATUS_BAR_EMBED_CODE_COPIED: 'Ora il Codice di Embed è copiato negli appunti!',

  THUMBNAIL_VIDEO_THUMBNAIL: 'Anteprima del video',

  TURNSTILE_DEFAULT_END: "Grazie per l'attenzione! \nPer favore inserisci il tuo indirizzo email.",
  TURNSTILE_DEFAULT_START: 'Inserisci il tuo indirizzo email per vedere questo video.',
  TURNSTILE_EMAIL_PLACEHOLDER: 'La tua email',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: 'Nome',
  TURNSTILE_LAST_NAME_PLACEHOLDER: 'Cognome',
  TURNSTILE_PLAY: 'Riprodurre',
  TURNSTILE_SUBMIT: 'Sottoscrivere',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: 'Slider del volume',
  VOLUME_TITLE_WHEN_MUTED: 'Rimettere audio',
  VOLUME_TITLE_WHEN_UNMUTED: 'Togliere audio',

  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: 'Il prossimo video verrà riprodotto tra...',
};
